module.exports = __webpack_public_path__ + "img/kerry_logo.927eaed5.png";